module.exports = __webpack_public_path__ + "img/mercado-de-la-boqueria.ca0ad67f.jpg";